<script>
    import {onMount} from 'svelte';
    import rpcjs from 'rpcjs';
    let travel = 'start';
    let roadmapText;
    let cat;
    let road;
    let roadBack;

    const {title, goto} = rpcjs.props;
    title.set('Roadmap');
    let buildings;
    onMount(onMountFunction);
    /**
     *
     *
     */
    function ani2020() {
        buildings.style.left = '-4.8vw';
        road.style.left = '-84.813vw';
        cat.style.left = '91vw';
    }
    /**
     *
     *
     */
    function ani2021() {
        buildings.style.left = '-9vw';
        road.style.left = '-190vw';
        cat.style.left = '201vw';
    }
    /**
     *
     *
     */
    function ani2022() {
        buildings.style.left = '-13vw';
        road.style.left = '-335vw';
        cat.style.left = '349vw';
    }
    /**
     *
     *
     */
    function ani20231() {
        buildings.style.left = '-17.5vw';
        road.style.left = '-450vw';
        cat.style.left = '471vw';
    }
    /**
     */
    function ani20232() {
        buildings.style.left = '-22vw';
        road.style.left = '-565vw';
        cat.style.left = '591vw';
    }
    /**
     */
    function ani20233() {
        buildings.style.left = '-26.5vw';
        road.style.left = '-680vw';
        cat.style.left = '713vw';
    }
    /**
     *
     *
     */
    function onMountFunction() {
        setTimeout(startAni, 10);
    }
    /**
     *
     *
     */
    function startAni() {
        cat.style.left = '0vw';
        cat.style.bottom = '4vw';
        road.style.bottom = '0vw';
        roadmapText.style.top = '7vw';
        setTimeout(ani2020, 2000);
    }

/**
*/
    function next() {
        if (travel=== 'start') {
            travel = 'ani2021';
            ani2021();
        } else if ( travel === 'ani2021') {
            travel = 'ani2022';
            ani2022();
        } else if ( travel === 'ani2022') {
            travel = 'ani20231';
            ani20231();
        } else if ( travel === 'ani20231') {
            travel = 'ani20232';
            ani20232();
        } else if ( travel === 'ani20232') {
            travel = 'ani20233';
            ani20233();
        } else if ( travel === 'end') {
            roadBack.style.top = '-20vw';
            setTimeout(()=>{
                goto('/moat');
            }, 200);
        } else {
            travel = 'end';
        }
    }
    /**
 * Adds two numbers together.
 * @param {int} e The first number.
 */
    function keycheck(e) {
        e.preventDefault();
        if (e.key == 'ArrowRight') {
            next();
        }
        if (e.key == 'ArrowLeft') {
            goto('/technology');
        }
    }
</script>

<svelte:window on:keyup={keycheck}/>

<div role = 'presentation' class="main-div" on:click={next}>
    <div role = "presentation" class="background-div">
        <div class="buildings-div" bind:this={buildings}>
            <img
                src="../images/roadmap/buildings.png"
                alt=""
                width="100%"
                height="100%"
            />
        </div>
        <div class="road-div" bind:this={road}>
            <img
                src="../images/roadmap/road.png"
                alt=""
                width="100%"
                height="100%"
            />
            <div class="D2020">
                <div class="technology-data">2020</div>
                <div class="technology-text">TECHNOLOGY PREVIEW</div>
            </div>
            <div class="D2021">
                <div class="technology-data">2021</div>
                <div class="technology-text">
                    MARKET VALIDATION <br> MODEL TRAINING
                </div>
            </div>
            <div class="D2022">
                <div class="technology-data">2022</div>
                <div class="technology-text">
                    PRIVATE BETA COMMUNITY WAITLIST
                </div>
            </div>
            <div class="D2023-1">
                <div class="technology-data">2023 - Q1</div>
                <div class="technology-text">
                    NFT LAUNCH<br>
                    <span> FOR GAME DEVELOPERS & COMMUNITY</span>
                </div>
            </div>
            <div class="D2023-2">
                <div class="technology-data">2023 - Q2</div>
                <div class="technology-text">
                    FIRST GAME ART AND WORLD <br> LAUNCH FOR AXIOM
                    
                </div>
            </div>
            <div class="D2023-3">
                <div class="technology-data">2023 - Q3</div>
                <div class="technology-text">
                    PUBLIC BETA
                    
                </div>
            </div>
           
            <div class="cat-div" bind:this={cat}>
                <img
                    src="../images/roadmap/cat.png"
                    alt=""
                    width="100%"
                    height="100%"
                />
            </div>
        </div>
    </div>
    <div class="roadmap-div" bind:this={roadmapText}>
        <div class="roadmap-text"
        bind:this={roadBack}>
            ROADMAP
        </div>
    </div>
</div>

<style>
    .main-div {
        width: 100%;
        height: 100vh;
        overflow: hidden;
        position: relative;
        font-family: "Montserrat";
    }
    .background-div {
        background-image: url("../images/roadmap/background.png");
        background-color: black;
        width: 133.021vw;
        height: 100vh;
        position: relative;
        background-size: cover;
    }
    .buildings-div {
        width: 133.021vw;
        height: 74.063vw;
        position: absolute;
        bottom: 7.885vw;
        left: 0;
        transition: left 2s;
    }
    .road-div {
        width: 956.563vw;
        height: 8.75vw;
        position: absolute;
        bottom: -6vw;
        left: 0;
        transition: bottom 2s, left 2s;
    }
    .cat-div {
        width: 21.354vw;
        height: 13.958vw;
        position: absolute;
        bottom: 8vw;
        left: -21vw;
        transition: bottom 2s, left 2s;
    }
    .roadmap-div {
        position: absolute;
        top: -4.5vw;
        transition: top 2s;
        left: 45.844vw;
        width: 40.938vw;
        height: 6.146vw;
    }
    .roadmap-text { 
        font-size: 7.813vw;
        font-weight: 900;
        color: #ff007f;
        position: absolute;
        top: 0vw;
        transition-duration: 0.5s;
    }
    .D2020, .D2021, .D2022,.D2023-1,.D2023-2, .D2023-3{
          display: flex;
        position: absolute;  
        flex-direction: column;
        gap: 1vw;
    }
    .D2020 {
      
        left: 112vw;
        bottom: 9vw;
      }
    .technology-data {
        width: 27.542vw;
        height: 4.115vw;
        font-size: 5.208vw;
        font-weight: 900;
        line-height: 5vw;
        color: #ff007f;
    }
    .technology-text {
        font-size: 3.125vw;
        color: white;
        width: 50.042vw;
        height: 2.448vw;
        line-height: 3vw;
        font-weight: 900;
    }
    .D2021 {
       
        left: 223vw;
        bottom: 9.5vw;
      
    }
    .D2022 {
       
        left: 371vw;
        bottom: 9.5vw;
        
    }
    .D2022 .technology-text {
        width: 40vw;
    }
    .D2023-1 {
       
        left: 493vw;
        bottom: 9.5vw;
    }
    .D2023-1 .technology-text{
        line-height: 2vw;
    }
    .D2023-1 .technology-text span{
        font-size: 1.563vw;
        line-height: 0vw;
        color: #FFCC33;
    }
    .D2023-2 {
      
        left: 613vw;
        bottom: 9.5vw;
    }
    .D2023-2 .technology-text{
        width:60vw;
    }
     
    .D2023-3 {
        left: 735vw;
        bottom: 9vw;
    
    }

</style>
